export default __webpack_public_path__ + "static/media/SWT0190.34I-27408_-16470_0.d2acce08.jpg";